var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHeaderTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 468,
    viewBox: "0 0 1440 468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.425 448.959C10.2991 404.835 -121.866 398.243 -198 472.885L-198 0H1638V535C1619.18 502.643 1542.12 440.134 1384.5 448.959C1187.47 459.99 1175.24 445.641 1004.43 435.182C824.657 424.174 651.832 504.113 295.425 448.959Z",
    fill: "#A2C7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHeaderTab);
export default __webpack_public_path__ + "static/media/BgHeaderTab.377ddaa2c75a1d248f9ef19b278d0543.svg";
export { ForwardRef as ReactComponent };